import {SetProperties} from "@/models/SetProperties";
import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";

export class BlockTriggerParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(BlockTrigger.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, BlockTrigger.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)) || el.id === item.id)
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => BlockTrigger.build(el))
    }
    return this
  }
}

export class BlockTrigger extends SetProperties{
  constructor() {
    super()
    this.id = null
    this.applicationType = null
    this.submissionSession = null
    this.startDateTime = null
    this.endDateTime = null
  }

  getForAPI() {
    return {
      id: this.id,
      applicationType: this.applicationType,
      submissionSession: this.submissionSession,
      startDateTime: this.startDateTime,
      endDateTime: this.endDateTime,
    }
  }

  static build(obj) {
    const _this = new BlockTrigger()
    if (obj) {
      _this.id = obj.id
      _this.applicationType = obj.applicationType
      _this.submissionSession = obj.submissionSession
      _this.startDateTime = obj.startDateTime
      _this.endDateTime = obj.endDateTime
    }
    return _this
  }
}
